import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'pxw-icon[icon="price-discount"]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../icon/icon.component.scss'],
  providers: [{ provide: IconComponent, useExisting: IconPriceDiscountComponent }],
  template: `
    <svg viewBox="0 0 45 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3096 29.6454L29.6448 16.3102"
        stroke="#FF7C7C"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.4208 18.5327C18.0346 18.5327 18.5321 18.0352 18.5321 17.4214C18.5321 16.8077 18.0346 16.3102 17.4208 16.3102C16.8071 16.3102 16.3096 16.8077 16.3096 17.4214C16.3096 18.0352 16.8071 18.5327 17.4208 18.5327Z"
        stroke="#FF7C7C"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.5331 29.6454C29.1469 29.6454 29.6444 29.1478 29.6444 28.5341C29.6444 27.9204 29.1469 27.4228 28.5331 27.4228C27.9194 27.4228 27.4219 27.9204 27.4219 28.5341C27.4219 29.1478 27.9194 29.6454 28.5331 29.6454Z"
        stroke="#FF7C7C"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.42004 12.3096C7.42004 11.0128 7.93519 9.76914 8.85217 8.85217C9.76914 7.93519 11.0128 7.42004 12.3096 7.42004H14.5321C15.8232 7.41931 17.0616 6.90798 17.9771 5.99762L19.5328 4.44185C19.9872 3.9849 20.5275 3.62227 21.1225 3.37483C21.7175 3.12738 22.3556 3 23 3C23.6444 3 24.2825 3.12738 24.8775 3.37483C25.4725 3.62227 26.0128 3.9849 26.4671 4.44185L28.0229 5.99762C28.9384 6.90798 30.1768 7.41931 31.4678 7.42004H33.6904C34.9872 7.42004 36.2309 7.93519 37.1478 8.85217C38.0648 9.76914 38.58 11.0128 38.58 12.3096V14.5321C38.5807 15.8232 39.092 17.0616 40.0024 17.9771L41.5581 19.5328C42.0151 19.9872 42.3777 20.5275 42.6252 21.1225C42.8726 21.7175 43 22.3556 43 23C43 23.6444 42.8726 24.2825 42.6252 24.8775C42.3777 25.4725 42.0151 26.0128 41.5581 26.4671L40.0024 28.0229C39.092 28.9384 38.5807 30.1768 38.58 31.4678V33.6904C38.58 34.9872 38.0648 36.2309 37.1478 37.1478C36.2309 38.0648 34.9872 38.58 33.6904 38.58H31.4678C30.1768 38.5807 28.9384 39.092 28.0229 40.0024L26.4671 41.5581C26.0128 42.0151 25.4725 42.3777 24.8775 42.6252C24.2825 42.8726 23.6444 43 23 43C22.3556 43 21.7175 42.8726 21.1225 42.6252C20.5275 42.3777 19.9872 42.0151 19.5328 41.5581L17.9771 40.0024C17.0616 39.092 15.8232 38.5807 14.5321 38.58H12.3096C11.0128 38.58 9.76914 38.0648 8.85217 37.1478C7.93519 36.2309 7.42004 34.9872 7.42004 33.6904V31.4678C7.41931 30.1768 6.90798 28.9384 5.99762 28.0229L4.44185 26.4671C3.9849 26.0128 3.62227 25.4725 3.37483 24.8775C3.12738 24.2825 3 23.6444 3 23C3 22.3556 3.12738 21.7175 3.37483 21.1225C3.62227 20.5275 3.9849 19.9872 4.44185 19.5328L5.99762 17.9771C6.90798 17.0616 7.41931 15.8232 7.42004 14.5321V12.3096Z"
        stroke="#FF7C7C"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class IconPriceDiscountComponent extends IconComponent {}
